import { Module } from "./Module";
import { Transput } from "./Transput";

export class LogoModule extends Module{
    ipAddress!: []
    transputs!: string[]
}
